import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import MainAnalytics from './MainAnalytics/MainAnalytics';
import InventoryItem from './InventoryItem/InventoryItem';

import './Analytics.css';

class Analytics extends Component {
    render() {
        return (
            <div className="analytics-home">
                <h5> <i className="ion ion-arrow-graph-up-right" /> Once you have an account, you'll be able to gain more insight on your sales here.</h5>

                <Switch>
                    <Route exact path='/analytics' component={MainAnalytics} />
                    <Route path='/analytics/:number' component={InventoryItem }/>
                </Switch>
            </div>
        );
    }
};

export default Analytics;



// WEBPACK FOOTER //
// ./src/components/App/components/Main/components/Analytics/Analytics.js